// extracted by mini-css-extract-plugin
export default {"paging":"Paging_paging__ytRl9"};